import { ChevronLeft, ChevronRight } from "lucide-react";

import { Button } from "@/components/ui/button";
import { isMonthAfter, monthLabel, shiftMonth } from "../../utils/format";

export function MonthPicker({
	value,
	max,
	onChange,
}: {
	value: string;
	max: string;
	onChange: (month: string) => void;
}) {
	const next = shiftMonth(value, 1);
	return (
		<div className="month-picker" data-month={value}>
			<Button
				type="button"
				variant="outline"
				size="icon"
				aria-label="Mês anterior"
				onClick={() => onChange(shiftMonth(value, -1))}
			>
				<ChevronLeft />
			</Button>
			<span className="month-picker__label" aria-live="polite">
				{monthLabel(value)}
			</span>
			<Button
				type="button"
				variant="outline"
				size="icon"
				aria-label="Próximo mês"
				disabled={isMonthAfter(next, max)}
				onClick={() => onChange(next)}
			>
				<ChevronRight />
			</Button>
		</div>
	);
}
